/** Represents an Onboarding Requirement for specific carrier */
export class OnboardingRequirementDto {
    public masterApprovalRequirementId: string = undefined;
    public carrierMasterApprovalRequirementId: string = undefined;
    public name: string = undefined;
    public description: string = undefined;
    public isComplete: boolean = undefined;
    public isWaived: boolean = undefined;
    public comment: string = undefined;
    public documentVersionId: string = undefined;
    public documentTitle: string = undefined;
    public carrierInsuranceId: number = undefined;
    public carrierEndorsementXrefId: string = undefined;
    public documentTypeIds: string = undefined;
    public endorsementTypeId: number = undefined;
    public endorsementDate: string = undefined;
    public displayOrder: number = undefined;
    public IsOptional: boolean = undefined;
    public conditionDescription: string = undefined;
    public subRequirements: OnboardingRequirementTypes[] = [];
    public hasApplicableDocuments: boolean = undefined;
    public isVerified:boolean = undefined;
    public verifiedStatus: "U" | "Y" | "N" = undefined;
    public verifiedByName: string = undefined;
    public verifiedOn: Date = undefined;
    public verificationTooltip:string = undefined;
    public isCategory: boolean = undefined;
    public requirements: OnboardingRequirementDto[] = [];
}

export class OnboardingRequirementTypeDto {
    public type: OnboardingRequirementTypes = undefined;
    public description: string = undefined;
}

export enum OnboardingRequirementTypes {
    document = 1,
    endorsement = 2
}
